const DATA_ROLE = "vanilla-slider";
const INITIALIZED_ATTR = "data-vanilla-slider-initialized";

export class VanillaSliderForm {
    public readonly root: HTMLElement;

    public readonly swiperEl: HTMLElement | null;

    public readonly prevBtn: HTMLElement | null;

    public readonly nextBtn: HTMLElement | null;

    public readonly progressBar: HTMLElement | null;

    public readonly sliderName: string;

    public constructor(root: HTMLElement) {
        this.root = root;
        this.swiperEl = root.querySelector<HTMLElement>(".vanilla-slider");
        this.prevBtn = root.querySelector<HTMLElement>(".slider-prev");
        this.nextBtn = root.querySelector<HTMLElement>(".slider-next");
        this.progressBar = root.querySelector<HTMLElement>(".carousel-progress__bar");
        this.sliderName = this.swiperEl?.getAttribute("data-vanilla-slider-name") ?? "";
    }

    public isInitialized(): boolean {
        return this.root.hasAttribute(INITIALIZED_ATTR);
    }

    public markInitialized(): void {
        this.root.setAttribute(INITIALIZED_ATTR, "1");
    }

    public static getRoots(parent: ParentNode | Document): HTMLElement[] {
        const roots: HTMLElement[] = [];
        // Include the root itself when it matches (e.g. when called per-element from initRegistry)
        if (parent instanceof HTMLElement && parent.matches(`[data-role="${DATA_ROLE}"]`)) {
            roots.push(parent);
        }
        parent.querySelectorAll<HTMLElement>(`[data-role="${DATA_ROLE}"]`).forEach((el) => {
            if (!roots.includes(el)) roots.push(el);
        });
        return roots;
    }
}
